<template>
  <Models />
</template>

<script lang="ts">
import Vue from 'vue';
import Models from '../components/Models.vue';

export default Vue.extend({
    components: {
        Models,
    },
});
</script>
